import React, { useState } from "react";

/**
 * ExpandableList renders <li> items with expand/collapse behavior.
 * @param {Object} props
 * @param {Array<any>} props.items - Array of raw items
 * @param {Function} props.renderItem - Function to render each item (like renderValue)
 * @param {number} props.visibleCount - Number of items to show initially
 */
const ExpandableList = ({ items = [], renderItem, visibleCount = 1 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!items?.length) return null;

  const visibleItems = items.slice(0, visibleCount);
  const hiddenItems = items.slice(visibleCount);

  return (
    <>
      {visibleItems.map((item, idx) => (
        <li key={idx}>{renderItem(item)}</li>
      ))}

      {!expanded && hiddenItems.length > 0 && (
        <li className="expandable-para-view-toggle-btn" style={{ cursor: "pointer" }} onClick={() => setExpanded(true)}>
          View More
        </li>
      )}
        {expanded && (
        <>
            {hiddenItems.map((item, idx) => (
            <li key={idx + visibleCount}>{renderItem(item)}</li>
            ))}

            <li className="expandable-para-view-toggle-btn" style={{ cursor: "pointer" }} onClick={() => setExpanded(false)}>
            View Less
            </li>
        </>
        )}

    </>
  );
};

export default ExpandableList;
